import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GalleryElement } from "../../store/Gallery";
import IF from "../common/IF";

interface Props {
  element: GalleryElement;
  showOverlay?: boolean;
  onClick?: () => void;
  applyPopupStyle?: boolean;
}

const GalleryItem = ({
  applyPopupStyle,
  element,
  showOverlay = false,
  onClick,
}: Props) => {
  const adjustedImageUrl = element.imageUrl.replace(/^.*[\\/]/, "");
  return (
    <div
      key={element.id}
      className={`wow fadeIn ${
        applyPopupStyle ? "popup-gallery-item" : "gallery-item"
      }`}
      onClick={onClick}
    >
      <div
        className={
          applyPopupStyle ? "popup-gallery-item-layer" : "gallery-item-layer"
        }
      >
        <div
          className={
            applyPopupStyle
              ? "popup-gallery-item-img-layer"
              : "gallery-item-img-layer"
          }
        >
          <LazyLoadImage
            style={{ minHeight: 260 }}
            placeholderSrc={`./resources/images/gallery/blur/${adjustedImageUrl}`}
            className={applyPopupStyle ? "popup-img" : "img"}
            key={`${element.id}`}
            src={`./resources/images/gallery/small/${adjustedImageUrl}`}
            alt={element.elementName}
          />
          <IF condition={showOverlay}>
            <div className="img-overlay"></div>
            <p className="category-title">{element.elementName}</p>
          </IF>
        </div>
      </div>
    </div>
  );
};

export default GalleryItem;
